<template>
  <div class="mobile-button" @click="$emit('click')">
    <slot />
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
@import '@/scss/variables.scss';
@import '@/scss/mixins.scss';
.mobile-button {
  align-items: center;
  background-color: #0f539c;
  border-radius: 50px;
  border-color: white;
  color: #fff;
  display: inline-flex;
  font-size: 18px;
  justify-content: center;
  height: 50px;
  width: 150px;
  @include hover();
}
</style>